import React from "react";
import T from "prop-types";
import { Row, Col } from "react-bootstrap";
import { withPolling } from "MODULES/shared/decorators";
import withCurrentUser from "MODULES/session/decorators/withCurrentUser";
import Stat from "MODULES/shared/components/Stat/Stat";
import numeral from "numeral";
import {
  PurchasesCount,
  PurchaseLinesCount,
  PurchasesSum,
  LotPurchasesSum,
  SrpTotal
} from "./Stats";

function HeaderStats({ currentUser, purchasesData }) {
  return [
    <Row>
      <Col md={4} lg={2}>
        <PurchasesCount dateLabel="Today" data={purchasesData} />
      </Col>
      <Col md={4} lg={2}>
        <PurchaseLinesCount dateLabel="Today" data={purchasesData} />
      </Col>
      {currentUser.locations.length > 1 &&
        purchasesData.perLocation.map(l => (
          <Col md={4} lg={2}>
            <Stat
              label={`$ Purchases ${l.name} - Today`}
              value={numeral(l.total_purchases).format("($0,0)")}
            />
          </Col>
        ))}
      <Col md={4} lg={2}>
        <LotPurchasesSum dateLabel="Today" data={purchasesData} />
      </Col>
    </Row>,
    <Row>
      <Col md={4} lg={2}>
        <PurchasesSum data={purchasesData} />
      </Col>
      <Col md={4} lg={2}>
        <Stat
          label={`$ Purchased For Stock`}
          value={numeral(
            purchasesData.purchased_for_stock_or_repair_assist
          ).format("($0,0)")}
        />
      </Col>
      <Col md={4} lg={2}>
        <Stat
          label={`$ Purchased For Repair`}
          value={numeral(purchasesData.purchased_for_repair_total).format(
            "($0,0)"
          )}
        />
      </Col>
      <Col md={4} lg={2}>
        <Stat
          label={`$ Purchased For Sale`}
          value={numeral(purchasesData.purchased_for_sale_total).format(
            "($0,0)"
          )}
        />
      </Col>
      <Col md={4} lg={2}>
        <SrpTotal data={purchasesData} />
      </Col>
    </Row>
  ];
}

HeaderStats.propTypes = {
  currentUser: T.shape({ locations: T.arrayOf(T.shape({})) }),
  purchasesData: T.arrayOf(T.shape({}))
};

export default withCurrentUser(withPolling(HeaderStats));



// WEBPACK FOOTER //
// ./app/modules/PurchasesDashboard/Components/HeaderStats.jsx